import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Table from 'components/shared/table/table'
import THead from 'components/shared/table/table-header'
import TBody from 'components/shared/table/table-body'
import TRow from 'components/shared/table/table-row-dropdown'
import TCol from 'components/shared/table/table-column'
import TablePagination from 'components/shared/table/table-pagination'
import SortedUp from 'components/shared/icons/sortedUp'
import SortedDown from 'components/shared/icons/sortedDown'
import SortIcon from 'components/shared/icons/sort'
import bookingActions from 'actions/bookings/actions'

const ArchiveListWon = ({
  fetchArchiveWonLeads,
  selectedVenue,
  list,
  page,
  limit,
  total,
  sortArchive,
  pageArchive,
  headers,
  sort,
}) => {
  useEffect(() => {
    fetchArchiveWonLeads({ selectedVenue })
  }, [page, limit, sort, selectedVenue])

  const DisplayDetails = (item) => {
    const { fromDetail, toDetail, notes, client, email, phone } = item

    return (
      <ul className="my-3 text-sm">
        <li>
          Request Date:
          <div className="flex">
            <div className="border-r-2 mx-1"></div>
            <div>
              <p className="text-sm">{`from: ${fromDetail}`}</p>
              <p className="text-sm">{`to: ${toDetail}`}</p>
            </div>
          </div>
        </li>
        <li>{`Notes: ${notes}`}</li>
        <li>{`Client Name: ${client}`}</li>
        <li>{`Email: ${email}`}</li>
        <li>{`Phone: ${phone}`}</li>
      </ul>
    )
  }

  return (
    <>
      <div className="overflow-auto py-5">
        <Table classes="w-full border-collapse">
          <THead classes="text-xs bg-lightgray font-semibold">
            {headers.map((header, key) => {
              let sortIcon = <SortIcon />
              let nextOrder = 'desc'

              if (sort.field === header.field) {
                if (sort.order === 'desc') {
                  sortIcon = <SortedDown />
                  nextOrder = 'asc'
                } else {
                  sortIcon = <SortedUp />
                }
              }

              return (
                <TCol
                  classes="p-3 text-primary-black"
                  key={key}
                  align={header.align || 'left'}
                  onClick={() =>
                    header.sortable &&
                    sortArchive({ sort: { field: header.field, order: nextOrder }, sub: 'wonLeads' })
                  }
                >
                  <div
                    className={`flex items-center gap-1 ${header.sortable ? 'cursor-pointer' : ''}`}
                  >
                    {header.name} {header.sortable && sortIcon}
                  </div>
                </TCol>
              )
            })}
          </THead>
          <TBody>
            {list.map((item) => (
              <TRow
                classes="border-t text-sm hover:bg-gray-100"
                key={item.id}
                PassedComponent={() => DisplayDetails(item.details)}
              >
                <TCol classes="p-3">{item.createDate}</TCol>
                <TCol classes="p-3">{item.date}</TCol>
                <TCol classes="p-3">{item.client}</TCol>
                <TCol classes="p-3 text-primary-orange">
                  <a href={item.spaceLink}>{item.space}</a>
                </TCol>
                <TCol classes="p-3">
                  <span className="bg-secondary-lightorange text-xs font-semibold text-primary-orange px-3 py-1 uppercase rounded-lg">
                    {item.status}
                  </span>
                </TCol>
                <TCol classes="p-3">{item.amount}</TCol>
              </TRow>
            ))}
          </TBody>
        </Table>
      </div>
      <TablePagination
        currentPage={page}
        onPageChange={(newPage) => pageArchive({ wonLeads: { page: newPage } })}
        onPageSizeChange={(newPageSize) => pageArchive({ wonLeads: { limit: newPageSize } })}
        pageSize={limit}
        totalCount={total}
        className="mt-5"
      />
    </>
  )
}

ArchiveListWon.propTypes = {
  headers: PropTypes.array.isRequired,
  list: PropTypes.array,
  selectedVenue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fetchArchiveWonLeads: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  pageArchive: PropTypes.func.isRequired,
  sort: PropTypes.object.isRequired,
  sortArchive: PropTypes.func.isRequired,
}

const mapStateToProps = ({ bookings }) => ({
  headers: bookings.merchant.archive.wonLeads.headers,
  sort: bookings.merchant.archive.wonLeads.sort,
  list: bookings.merchant.archive.wonLeads.list,
  page: bookings.merchant.archive.wonLeads.page,
  limit: bookings.merchant.archive.wonLeads.limit,
  total: bookings.merchant.archive.wonLeads.total,
})

const mapDispatchToProps = {
  fetchArchiveWonLeads: bookingActions.fetchMerchantWonArchivedLeads,
  pageArchive: bookingActions.pageMerchantArchive,
  sortArchive: bookingActions.sortMerchantArchive,
}

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveListWon)
